module.exports = __webpack_public_path__ + "img/ttshop_tk.7e71dcc9.svg";